module.exports = __webpack_public_path__ + "static/media/wb_i9_configure_page.804480e1.png";